import { render } from "./AppLayoutHeader.vue?vue&type=template&id=64bc00e8"
const script = {}
script.render = render

export default script